import { useEffect } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import ServiceHero from "./components/ServiceHero";
import EquipmentTypes from "./components/EquipmentTypes";
import WhyChoose from "./components/WhyChoose";
import BrandShowcase from "./components/BrandShowcase";
import ServiceCta from "./components/ServiceCta";

export default function VentaEquipos() {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <ServiceHero />
        <EquipmentTypes />
        <WhyChoose />
        <BrandShowcase />
        <ServiceCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}